import TranslationText from '@Components/Utilities/TranslationText';
import Modal from '@Components/Shared/Modals/Modal';

const ClassicViewModal = (props) => {

    return (
        <Modal containerClassName='classic-view-modal' onEscapeKeyClose={props.toggleModal}>
            <Modal.Header onClose={props.toggleModal} />
            <Modal.Body>
                <TranslationText tKey='sandhills.tradesites.mvc.clickbelowforclassicview' />
                <a href={props.ClassicViewURL} id='mobile-classic-view-link'>
                    <img src={props.ClassicViewImageURL} alt="" />
                </a>
            </Modal.Body>
        </Modal>
    );
}

export default ClassicViewModal;